// ==============================|| SHARED REQUESTS ||============================== //
//
// Reference data — the users, teams and stores directories, the workflow list
// — changes rarely but is read by many screens (the ticket list, then every
// ticket opened from it). A shared request is fetched once, handed to every
// caller asking at the same time, and reused for a few minutes. Failed loads
// are never kept, and the matching admin edits clear the copy right away.

const DEFAULT_TTL = 5 * 60 * 1000;
const entries = new Map();

export const sharedRequest = (key, load, ttl = DEFAULT_TTL) => {
  const hit = entries.get(key);
  if (hit && (hit.pending || Date.now() - hit.at < ttl)) return hit.promise;
  const entry = { pending: true, at: 0 };
  entry.promise = load().then(
    (res) => {
      entry.pending = false;
      entry.at = Date.now();
      if (res?.success === false) entries.delete(key);
      return res;
    },
    (err) => {
      entries.delete(key);
      throw err;
    },
  );
  entries.set(key, entry);
  return entry.promise;
};

// Drop every shared copy whose key starts with `prefix`, so the next read
// fetches fresh data (after creating / editing / deleting the thing behind it).
export const clearShared = (prefix) => {
  [...entries.keys()].forEach((k) => {
    if (k.startsWith(prefix)) entries.delete(k);
  });
};
